// src/App.js

import React, {

  useEffect,

  useState,

} from "react";

import {

  BrowserRouter as Router,

  Navigate,

  Route,

  Routes,

} from "react-router-dom";

import {

  ToastContainer,

} from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import "slick-carousel/slick/slick.css";

import "slick-carousel/slick/slick-theme.css";

// ===== Landing =====

import Hero from "./components/hero";

import Benefits from "./components/benefits";

import Testimonial from "./components/Testimonial";

import Plan from "./components/differential";

import HowItWorks from "./components/howItWorks";

import Faq from "./components/faq";

import CtaBanner from "./components/ctaBanner";

import Footer from "./components/footer";

import Partnership from "./components/Partnership";

import WhatsAppButton from "./components/whatsappButton";

import LandingShell from "./components/landing/LandingShell";

import SiteHeader from "./components/landing/SiteHeader";

import RoutineSection from "./components/landing/RoutineSection";

import PsyaNote from "./components/landing/PsyaNote";

// ===== Meta Pixel =====

import MetaPixelRouteTracker from "./components/MetaPixelRouteTracker";

// ===== Páginas públicas legais =====

import PrivacyPolicy from "./components/PrivacyPolicy";

import TermsOfUsePublic from "./components/TermsOfUsePublic";

import TermsOfUse from "./components/termosDeUso";

// ===== Administração interna =====

import AdminApp from "./components/admin/AdminApp";

// ===== Fluxo de autenticação / assinatura =====

import Login from "./components/login";

import Register from "./components/register";

import Essencial from "./components/essencial";

import Premium from "./components/premium";

import CadastroScreen from "./components/cadastroScreen";

import CadastroDetalhesScreen from "./components/cadastroDetalhesScreen";

import Payment from "./components/payment";

import PaymentSuccess from "./components/payment_success";

import ForgotPasswordScreen from "./components/ForgotPasswordScreen";

import VerifyCodeScreen from "./components/VerifyCodeScreen";

import ResetPasswordScreen from "./components/ResetPasswordScreen";

import PasswordResetSuccessScreen from "./components/PasswordResetSuccessScreen";

import StripeCheckoutWebViewScreen from "./components/StripeCheckoutWebViewScreen";

import AnamneseScreen from "./components/AnamneseScreen";

// ===== App autenticado =====

import DashboardScreen from "./components/DashboardScreen";

import {

  limparSessaoAutenticacao,

  obterTokenAutenticacao,

  sincronizarUsuarioAtual,

} from "./services/userServices";

// ===== Agenda =====

import ScheduleScreen from "./components/ScheduleScreen";

import AddAppointmentScreen from "./components/AddAppointmentScreen";

import SessionControlScreen from "./components/SessionControlScreen";

import OpenSessionsScreen from "./components/OpenSessionsScreen";

// ===== Clientes =====

import ClientsListScreen from "./components/ClientsListScreen";

import ClientScreen from "./components/ClientsScreen";

import ClientDetailsScreen from "./components/ClientDetailsScreen";

import AddProntuarioScreen from "./components/AddProntuarioScreen";

// ===== Financeiro =====

import FinanceScreen from "./components/FinanceScreen";

import FinanceOverviewScreen from "./components/FinanceOverviewScreen";

import RevenueListScreen from "./components/RevenueListScreen";

import ExpenseListScreen from "./components/ExpenseListScreen";

import AddRevenueScreen from "./components/AddRevenueScreen";

import AddExpenseScreen from "./components/AddExpenseScreen";

// ===== Relatórios =====

import ReportsScreen from "./components/ReportsScreen";

import FinancialReportScreen from "./components/FinancialReportScreen";

import RevenueReportScreen from "./components/RevenueReportScreen";

import ExpenseReportScreen from "./components/ExpenseReportScreen";

import BalanceReportScreen from "./components/BalanceReportScreen";

import ReportSaudeScreen from "./components/ReportSaudeScreen";

import SessionsReportScreen from "./components/SessionsReportScreen";

import PatientsReportScreen from "./components/PatientsReportScreen";

import EngagementReportScreen from "./components/EngagementReportScreen";

import AppointmentsReportScreen from "./components/AppointmentsReportScreen";

import ReportLeadsScreen from "./components/ReportLeadsScreen";

import CobrancaPendenciasScreen from "./components/CobrancaPendenciasScreen";

import LaunchSessionScreen from "./components/LaunchSessionScreen";

import ConfirmarSessaoScreen from "./components/ConfirmarSessaoScreen";

import IntegrationScreen from "./components/IntegrationsScreen";

import CommunicationsScreen from "./components/CommunicationsScreen";

// ===== Leads + Config =====

import LeadsScreen from "./components/LeadsScreen";

import AddLeadScreen from "./components/AddLeadScreen";

import ConfigScreen from "./components/ConfigScreen";

import ProfileScreen from "./components/ProfileScreen";

import SecurityScreen from "./components/SecurityScreen";

import PlanManagementScreen from "./components/PlanManagementScreen";

import HelpScreen from "./components/HelpScreen";

const Landing = () => (
  <LandingShell>
    <SiteHeader />
    <main id="conteudo">
      <Hero />
      <RoutineSection />
      <Benefits />
      <HowItWorks />
      <Testimonial />
      <PsyaNote />
      <Plan />
      <Faq />
      <Partnership />
      <CtaBanner />
    </main>
    <Footer />
    <WhatsAppButton />
  </LandingShell>
);

const ProtectedRoute = ({

  children,

}) => {

  const token =

    obterTokenAutenticacao();

  const [

    status,

    setStatus,

  ] = useState(

    token

      ? "sincronizando"

      : "sem-token"

  );

  useEffect(() => {

    let mounted = true;

    async function sincronizar() {

      if (!token) {

        if (mounted) {

          setStatus(

            "sem-token"

          );

        }

        return;

      }

      try {

        await sincronizarUsuarioAtual();

        if (mounted) {

          setStatus(

            "autorizado"

          );

        }

      } catch (error) {

        console.error(

          "Erro ao sincronizar usuário autenticado:",

          error

        );

        const statusHttp =

          Number(

            error?.status || 0

          );

        if (

          statusHttp === 401 ||

          statusHttp === 403

        ) {

          limparSessaoAutenticacao();

          if (mounted) {

            setStatus(

              "sem-token"

            );

          }

          return;

        }

        if (mounted) {

          setStatus(

            "autorizado"

          );

        }

      }

    }

    sincronizar();

    return () => {

      mounted = false;

    };

  }, [token]);

  if (

    !token ||

    status === "sem-token"

  ) {

    return (

      <Navigate

        to="/login"

        replace

      />

    );

  }

  if (

    status === "sincronizando"

  ) {

    return (

      <div

        style={{

          minHeight: "100vh",

          display: "grid",

          placeItems: "center",

          padding: 24,

        }}

      >

        <p>

          Sincronizando sua conta...

        </p>

      </div>

    );

  }

  return children;

};

const Placeholder = ({

  title,

}) => (

  <div

    style={{

      padding: 24,

    }}

  >

    <h2>

      {title}

    </h2>

    <p>

      Em construção.

    </p>

  </div>

);

const App = () => {

  return (

    <Router>

      {/* Rastreamento de navegação SPA para o Meta Pixel */}

      <MetaPixelRouteTracker />

      <ToastContainer

        position="top-right"

        autoClose={2500}

        hideProgressBar={false}

        newestOnTop

        closeOnClick

        pauseOnHover

        draggable

        theme="light"

      />

      <Routes>

        {/* ===== Público ===== */}

        <Route

          path="/"

          element={<Landing />}

        />

        <Route

          path="/login"

          element={<Login />}

        />

        {/*

         * Páginas legais públicas.

         * Não exigem autenticação.

         */}

        <Route

          path="/privacidade"

          element={

            <PrivacyPolicy />

          }

        />

        <Route

          path="/termos-de-uso"

          element={

            <TermsOfUsePublic />

          }

        />

        {/*

         * Termos contratuais do fluxo de cadastro.

         * Possui checkbox obrigatório de aceite antes de seguir para o cadastro.

         */}

        <Route

          path="/termos"

          element={<TermsOfUse />}

        />

        {/* Alias semântico para o contrato de contratação. */}

        <Route

          path="/contratacao/termos"

          element={<TermsOfUse />}

        />

        {/*

         * Confirmação pública de sessão.

         */}

        <Route

          path="/confirmar-sessao"

          element={

            <ConfirmarSessaoScreen />

          }

        />

        {/* ===== Conta / planos ===== */}

        <Route

          path="/register"

          element={<Register />}

        />

        <Route

          path="/plan-essential"

          element={<Essencial />}

        />

        <Route

          path="/plan-premium"

          element={<Premium />}

        />

        <Route

          path="/cadastro"

          element={

            <CadastroScreen />

          }

        />

        <Route

          path="/cadastro-detalhes"

          element={

            <CadastroDetalhesScreen />

          }

        />

        <Route

          path="/payment"

          element={<Payment />}

        />

        <Route

          path="/payment-success"

          element={

            <PaymentSuccess />

          }

        />

        <Route

          path="/payment-success/:sessionId"

          element={

            <PaymentSuccess />

          }

        />

        <Route

          path="/payment-checkout-webview"

          element={

            <StripeCheckoutWebViewScreen />

          }

        />

        {/* ===== Recuperação de senha ===== */}

        <Route

          path="/forgot-password"

          element={

            <ForgotPasswordScreen />

          }

        />

        <Route

          path="/verify-code"

          element={

            <VerifyCodeScreen />

          }

        />

        <Route

          path="/reset-password"

          element={

            <ResetPasswordScreen />

          }

        />

        <Route

          path="/password-reset-success"

          element={

            <PasswordResetSuccessScreen />

          }

        />

        {/* ===== App autenticado ===== */}

        <Route

          path="/dashboard"

          element={

            <ProtectedRoute>

              <DashboardScreen />

            </ProtectedRoute>

          }

        />

        {/* ===== Agenda ===== */}

        <Route

          path="/schedule"

          element={

            <ProtectedRoute>

              <ScheduleScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/schedule/new"

          element={

            <ProtectedRoute>

              <AddAppointmentScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/schedule/edit"

          element={

            <ProtectedRoute>

              <AddAppointmentScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/open-sessions"

          element={

            <ProtectedRoute>

              <OpenSessionsScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/session-control"

          element={

            <ProtectedRoute>

              <SessionControlScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/sessions"

          element={

            <ProtectedRoute>

              <Navigate

                to="/session-control"

                replace

              />

            </ProtectedRoute>

          }

        />

        {/* ===== Clientes ===== */}

        <Route

          path="/clients"

          element={

            <ProtectedRoute>

              <ClientsListScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/clients/new"

          element={

            <ProtectedRoute>

              <ClientScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/clients/edit"

          element={

            <ProtectedRoute>

              <ClientScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/clients/details"

          element={

            <ProtectedRoute>

              <ClientDetailsScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/clients/anamnese"

          element={

            <ProtectedRoute>

              <AnamneseScreen />

            </ProtectedRoute>

          }

        />

        {/* ===== Prontuário ===== */}

        <Route

          path="/prontuario/new"

          element={

            <ProtectedRoute>

              <AddProntuarioScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/prontuario/edit"

          element={

            <ProtectedRoute>

              <AddProntuarioScreen />

            </ProtectedRoute>

          }

        />

        {/* ===== Financeiro ===== */}

        <Route

          path="/finance"

          element={

            <ProtectedRoute>

              <FinanceScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/finance/overview"

          element={

            <ProtectedRoute>

              <FinanceOverviewScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/finance/revenues"

          element={

            <ProtectedRoute>

              <RevenueListScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/finance/expenses"

          element={

            <ProtectedRoute>

              <ExpenseListScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/finance/revenue/new"

          element={

            <ProtectedRoute>

              <AddRevenueScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/finance/revenue/edit"

          element={

            <ProtectedRoute>

              <AddRevenueScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/finance/expense/new"

          element={

            <ProtectedRoute>

              <AddExpenseScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/finance/expense/edit"

          element={

            <ProtectedRoute>

              <AddExpenseScreen />

            </ProtectedRoute>

          }

        />

        {/* ===== Sessões ===== */}

        <Route

          path="/launch-session"

          element={

            <ProtectedRoute>

              <LaunchSessionScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/sessions/new"

          element={

            <ProtectedRoute>

              <LaunchSessionScreen />

            </ProtectedRoute>

          }

        />

        {/* ===== Relatórios ===== */}

        <Route

          path="/finance/revenue/report"

          element={

            <ProtectedRoute>

              <RevenueReportScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports"

          element={

            <ProtectedRoute>

              <ReportsScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports/revenue"

          element={

            <ProtectedRoute>

              <Navigate

                to="/finance/revenue/report"

                replace

              />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports/expense"

          element={

            <ProtectedRoute>

              <ExpenseReportScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports/balance"

          element={

            <ProtectedRoute>

              <BalanceReportScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports/saude"

          element={

            <ProtectedRoute>

              <ReportSaudeScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports/sessions"

          element={

            <ProtectedRoute>

              <SessionsReportScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports/patients"

          element={

            <ProtectedRoute>

              <PatientsReportScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports/engagement"

          element={

            <ProtectedRoute>

              <EngagementReportScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports/appointments"

          element={

            <ProtectedRoute>

              <AppointmentsReportScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports/leads"

          element={

            <ProtectedRoute>

              <ReportLeadsScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/reports/financial"

          element={

            <ProtectedRoute>

              <FinancialReportScreen />

            </ProtectedRoute>

          }

        />

        {/* ===== Integrações ===== */}

        <Route

          path="/integrations"

          element={

            <ProtectedRoute>

              <IntegrationScreen />

            </ProtectedRoute>

          }

        />

        {/* ===== Comunicações ===== */}

        <Route

          path="/communications"

          element={

            <ProtectedRoute>

              <CommunicationsScreen />

            </ProtectedRoute>

          }

        />

        {/* ===== Cobrança ===== */}

        <Route

          path="/cobranca"

          element={

            <ProtectedRoute>

              <CobrancaPendenciasScreen />

            </ProtectedRoute>

          }

        />

        {/* ===== Leads ===== */}

        <Route

          path="/leads"

          element={

            <ProtectedRoute>

              <LeadsScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/leads/new"

          element={

            <ProtectedRoute>

              <AddLeadScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/leads/edit"

          element={

            <ProtectedRoute>

              <AddLeadScreen />

            </ProtectedRoute>

          }

        />

        {/* ===== Configurações ===== */}

        <Route

          path="/settings"

          element={

            <ProtectedRoute>

              <ConfigScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/profile"

          element={

            <ProtectedRoute>

              <ProfileScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/security"

          element={

            <ProtectedRoute>

              <SecurityScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/notifications"

          element={

            <ProtectedRoute>

              <Placeholder title="Notificações" />

            </ProtectedRoute>

          }

        />

        <Route

          path="/plan-management"

          element={

            <ProtectedRoute>

              <PlanManagementScreen />

            </ProtectedRoute>

          }

        />

        <Route

          path="/help"

          element={

            <ProtectedRoute>

              <HelpScreen />

            </ProtectedRoute>

          }

        />

        {/*

         * Administração interna.

         * Não existe link para esta rota na landing page nem no AppSidebar.

         * A segurança real é feita no backend por permissao=admin.

         */}

        <Route

          path="/admin"

          element={<AdminApp />}

        />

        {/* ===== Fallback ===== */}

        <Route

          path="*"

          element={

            obterTokenAutenticacao()

              ? (

                <Navigate

                  to="/dashboard"

                  replace

                />

              )

              : (

                <Navigate

                  to="/login"

                  replace

                />

              )

          }

        />

      </Routes>

    </Router>

  );

};

export default App;
